import { useFormikContext } from 'formik'
import React from 'react'
import SettingsFormContainer from 'src/Elements/SystemSettings/forms/SettingsFormContainer'
import { SettingsBox } from 'src/Elements/Data'
import { NumberField } from 'src/Libs/inputs/formik'
import { KeysOfFeedInModel } from '../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { UnitTypes } from 'src/Libs/types'
import { SingleToggleSettingBox } from 'src/Elements/SystemSettings/forms'
import { useMediaQuery, useTheme } from '@mui/material'
import { FeedInPowerModel } from '../model'

interface Props {
  disabled?: boolean
}

const INSTALLED_PV_POWER_NAME: KeysOfFeedInModel = 'installedPvPower'
const CONNECTED_POWER_NAME: KeysOfFeedInModel = 'connectedPower'
const POWER_REDUCTION_NAME: KeysOfFeedInModel = 'powerReduction'
const POWER_REDUCTION_RELATED_TO_NAME: KeysOfFeedInModel = 'powerReductionRelatedTo'
const BACKUP_CURRENT: KeysOfFeedInModel = 'backupCurrent'

const THREE_FUSES_SYMBOL = 'x3'

/**
 * Displays a form for the installation settings
 */
const InstallationSettingsForm: React.VFC<Props> = ({ disabled = false }) => {
  const { initialValues } = useFormikContext<FeedInPowerModel>()
  const { t } = useCustomTranslation()

  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <SettingsFormContainer model={initialValues}>
      <SettingsBox
        title={t('systemSettings.installation.settings.installed-pv-power')}
        suffix={
          <NumberField
            name={INSTALLED_PV_POWER_NAME}
            label={t('systemSettings.installation.settings.installed-pv-power')}
            suffix={UnitTypes.watt}
            disabled={disabled}
            fullWidth={downMd}
            data-qa="installation-settings-installed-pv-power"
          />
        }
        disabled={disabled}
      />
      <SettingsBox
        title={t('systemSettings.installation.settings.connected-power')}
        suffix={
          <NumberField
            name={CONNECTED_POWER_NAME}
            label={t('systemSettings.installation.settings.connected-power')}
            suffix={UnitTypes.watt}
            disabled={disabled}
            fullWidth={downMd}
            data-qa="installation-settings-connected-power"
          />
        }
        disabled={disabled}
      />
      <SettingsBox
        title={t('systemSettings.installation.settings.power-reduction')}
        disabled={disabled}
        suffix={
          <NumberField
            name={POWER_REDUCTION_NAME}
            label={t('systemSettings.installation.settings.power-reduction')}
            suffix={UnitTypes.percentage}
            disabled={disabled}
            fullWidth={downMd}
            data-qa="installation-settings-power-reduction"
          />
        }
      />
      <SingleToggleSettingBox
        name={POWER_REDUCTION_RELATED_TO_NAME}
        title={t('systemSettings.installation.settings.power-reduction-related-to.title')}
        trueLabel={t('systemSettings.installation.settings.power-reduction-related-to.photovoltaic-power')}
        falseLabel={t('systemSettings.installation.settings.power-reduction-related-to.connected-power')}
        disabled={disabled}
        data-qa="installation-settings-power-reduction-related-to"
      />
      <SettingsBox
        title={t('systemSettings.installation.settings.max-fuse-power')}
        suffix={
          <NumberField
            name={BACKUP_CURRENT}
            label={t('systemSettings.installation.settings.max-fuse-power')}
            suffix={UnitTypes.ampere}
            prefix={THREE_FUSES_SYMBOL}
            disabled={disabled}
            fullWidth={downMd}
            data-qa="installation-settings-max-fuse-power"
          />
        }
        disabled={disabled}
      />
    </SettingsFormContainer>
  )
}

export default InstallationSettingsForm
